<template>
  <div :class="containerClasses">
    <a v-if="href" target="_blank" :href="href">
      <v-lazy-image
        v-if="lazyLoad"
        ref="lazyImage"
        :src="src"
        class="img__badge"
        :src-placeholder="src ? 'https://i.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.webp' : ''"
        @load="onImageLoad"
      ></v-lazy-image>
      <img v-else :src="src" class="img__badge" @load="onImageLoad" />
    </a>

    <v-lazy-image
      v-else-if="lazyLoad"
      ref="lazyImage"
      :src="src"
      class="img__badge"
      :src-placeholder="src ? 'https://i.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.webp' : ''"
      @load="onImageLoad"
    ></v-lazy-image>
    <img v-else :src="src" class="img__badge" @load="onImageLoad" />
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },

    href: {
      type: String,
      default: ''
    },

    large: {
      type: Boolean,
      default: false
    },

    centered: {
      type: Boolean,
      default: false
    },

    lazyLoad: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isLoaded: false
    };
  },

  computed: {
    containerClasses() {
      return {
        container__badge: true,
        'container__badge--large': this.large,
        'container__badge--centered': this.centered
      };
    }
  },

  methods: {
    onImageLoad() {
      this.isLoaded = true;
      this.$emit('image-loaded');
    },

    // Method to check if image is fully loaded
    isImageLoaded() {
      return this.isLoaded;
    }
  }
};
</script>
